module.exports = __webpack_public_path__ + "static/img/best_pizza_2.2d9b896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/best_pizza_2.png
// module id = DjUB
// module chunks = 0